if (!customElements.get('bf-product-share')) {
  customElements.define('bf-product-share', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.details = this.querySelector('details');
      this.trigger = this.querySelector('summary');
      this.input = this.querySelector('input');
      this.status = this.querySelector('[role="status"]');
      this.trigger.addEventListener('click', async event => {
        event.stopPropagation();
        this.input.value = this.shareURL();
        this.status.textContent = '';
        if (this.details.open || typeof navigator.share !== 'function') return;
        event.preventDefault();
        if (this.sharing) return;
        this.sharing = true;
        try {
          await navigator.share({title: this.dataset.title, url: this.input.value});
        } catch (error) {
          if (error.name !== 'AbortError') this.details.open = true;
        } finally {
          this.sharing = false;
        }
      });
      this.querySelector('[data-copy]').addEventListener('click', async event => {
        event.stopPropagation();
        this.input.value = this.shareURL();
        try {
          await navigator.clipboard.writeText(this.input.value);
          this.status.textContent = this.dataset.copied;
        } catch {
          this.input.focus();
          this.input.select();
          this.status.textContent = this.dataset.manual;
        }
      });
      this.querySelector('[data-close]').addEventListener('click', () => this.close());
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          this.close();
        }
      });
    }
    shareURL() {
      const url = new URL(this.dataset.url);
      if (this.hasAttribute('data-product-detail')) {
        const scope = this.closest('.shopify-section');
        const variant = scope?.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
        if (variant && /^\d+$/.test(variant)) url.searchParams.set('variant', variant);
      }
      return url.href;
    }
    close() {
      this.details.open = false;
      this.trigger.focus();
    }
  });
}
